import React from 'react'
import { Container } from 'reactstrap'
import RegisterCompanyCreate from '../../../../Components/settings/Company/RegisterCompany/RegisterCompanyCreate'
function RegisteredCompanyCreatingPage() {
    return (
        <div className='page-body'>
            <Container fluid>
                <RegisterCompanyCreate />
            </Container>
        </div>
    )
}

export default RegisteredCompanyCreatingPage